import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { formatGameTime } from "../format/formatGameTime";
import { formatPickRate } from "../format/formatPickRate";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";

const TITLE = msg({ id: "finding.core_item_missing", message: "{item}: not bought" });

const DETAILS = msg({
  id: "finding.core_item_missing.details",
  message: "{pickRate} of strong players on this hero buy it, on average by {baseline}.",
});

const SUMMARY = msg({
  id: "finding.core_item_missing.summary",
  message: "{pickRate} of strong players take it",
});

// Ключевой предмет сильных игроков на герое не куплен вообще.
export const CoreItemMissing = ({ finding, variant }: FindingProps<"core_item_missing">) => {
  const { i18n } = useLingui();
  const item = useAssetLookup("items")(finding.params.item_id);
  const pickRate = formatPickRate(finding.params.pick_rate, i18n.locale);
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<AssetIcon asset={item} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { item: item.name } })}
      details={i18n._({
        ...DETAILS,
        values: { pickRate, baseline: formatGameTime(finding.params.baseline_at_s) },
      })}
      summary={i18n._({ ...SUMMARY, values: { pickRate } })}
    />
  );
};
